var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-dropdown-item',{attrs:{"to":{
      name: 'map',
      params: {
        type: 'charging'
      }
    }}},[_vm._v("Charging Stations")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }